import { isNullOrEmpty } from '@pcty/utils';
/**
 * Function for inserting a series of characters at specified indexes. Use this function to help you create your own formatters.
 * @param {string} value - The original string
 * @param {Array<{char: string, index: number}>} chars - Array of {char, index} objects
 * @param {(value: string) => string} [preFormatFilter] - Optional function to filter the string before inserting formatting chars (i.e. removing all non-numeric chars)
 * @return {string} - The string with the characters inserted at the specified indexes
 */
export var insertChars = function (value, chars, preFormatFilter) {
    if (preFormatFilter === void 0) { preFormatFilter = null; }
    if (isNullOrEmpty(value))
        return '';
    var insertAt = function (str, value, index) {
        if (str === null)
            return value;
        return str.slice(0, index) + value + str.slice(index);
    };
    if (preFormatFilter) {
        value = preFormatFilter(value.toString());
    }
    for (var _i = 0, chars_1 = chars; _i < chars_1.length; _i++) {
        var c = chars_1[_i];
        if (value.toString().length >= c.index) {
            value = insertAt(value, c.char, c.index);
        }
        else {
            return value.toString();
        }
    }
    return value.toString();
};
